// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import colors from 'vuetify/lib/util/colors'
import { ca, es, en, fr, pt } from 'vuetify/locale'

// import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

const idioma = localStorage.getItem('locale') == null ? "es" : localStorage.getItem('locale') === "es_ct" ? "ca" : localStorage.getItem('locale'); 

export default createVuetify({
    components,
    directives,
    locale: {
      locale: idioma,
      fallback: "es",
      messages: { es, en, ca, fr, pt },
    },
    theme: {
      defaultTheme: 'lightTheme',
      themes: {
        lightTheme: {
          dark: false,
          variables: {}, // ✅ this property is required to avoid Vuetify crash
          typography: {
            fontFamily: 'Montserrat', // Establecer la familia de fuentes por defecto
          },
          colors: {
            // greenish: '#03DAC5',
  
            // Workaround: Custom colors seem to erase default colors, so we need to include the default colors (of `light` or `dark` theme)
            background: '#fbfbfb',
            surface: '#FFFFFF',
            primary: '#EAE6E9',
            // 'primary-darken-1': '#3700B3',
            secondary: colors.green.darken1,
            // 'secondary-darken-1': '#03DAC5',
            error: '#CF6679',
            info: '#2196F3',
            success: '#4CAF50',
            warning: '#FB8C00'
          },
        },
        darkTheme: {
          dark: true,
          variables: {}, // ✅ this property is required to avoid Vuetify crash
          typography: {
            fontFamily: 'Montserrat', // Establecer la familia de fuentes por defecto
          },
          colors: {
            //green: '#00ff00' // cannot use primary color names here, so use a custom color name (such as 'greenish')
            // greenish: '#03DAC5',
  
            // Workaround: Custom colors seem to erase default colors, so we need to include the default colors (of `light` or `dark` theme)
            background: '#111928',
            surface: '#212121',
            primary: colors.green.darken1,
            // 'primary-darken-1': '#3700B3',
            secondary: colors.green.darken1,
            // 'secondary-darken-1': '#03DAC5',
            error: '#CF6679',
            info: '#2196F3',
            success: '#4CAF50',
            warning: '#FB8C00'
          },
        }
      }
    }
  })